import React from 'react';

// Compact label, in the Fluid Functionalism badge shape: a solid tint, or a
// neutral outline with a colored dot. Text stays the foreground color so it
// keeps its contrast on every hue. Gray is the neutral fill, not a tint.

const COLORS = {
  accent: 'var(--edl-accent)',
  gray: '#a3a3a3',
  red: '#ef4444',
  orange: '#f97316',
  amber: '#f59e0b',
  yellow: '#eab308',
  lime: '#84cc16',
  green: '#22c55e',
  emerald: '#10b981',
  teal: '#14b8a6',
  cyan: '#06b6d4',
  blue: '#3b82f6',
  indigo: '#6366f1',
  violet: '#8b5cf6',
  purple: '#a855f7',
  fuchsia: '#d946ef',
  pink: '#ec4899',
  rose: '#f43f5e',
};

const LEGACY_SIZE = { sm: 'compact', md: 'default', lg: 'default' };

export function Badge({
  variant = 'solid',
  size = 'default',
  color = 'gray',
  className,
  style,
  children,
  ...props
}) {
  const resolved = LEGACY_SIZE[size] ?? size;
  const hue = COLORS[color] ?? COLORS.gray;
  const solid = variant !== 'dot';
  const colorStyle = solid && color !== 'gray'
    ? { color: 'var(--edl-fg)', backgroundColor: `color-mix(in srgb, ${hue} 15%, var(--edl-bg))` }
    : undefined;
  const dotColor = color === 'gray' ? 'var(--edl-fg-muted)' : hue;
  return (
    <span
      {...props}
      className={['edl-badge', className].filter(Boolean).join(' ')}
      data-variant={solid ? 'solid' : 'dot'}
      data-size={resolved}
      data-color={color}
      style={{ ...colorStyle, ...style }}
    >
      {!solid && <span className="edl-badge__dot" style={{ backgroundColor: dotColor }} />}
      {children}
    </span>
  );
}
